module.exports = __webpack_public_path__ + "img/documents-icon.2b9da155.svg";